import React, { useState } from 'react';
import { Button, Col, Form, ListGroup, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';


const UserInformation = ({ formData, setFormData, error }) => {
    const [validated, setValidated] = useState(false);
    const [currentParticipant, setCurrentParticipant] = useState({
        firstName: '',
        lastName: '',
        designation: '',
        contact: '',
    });

    const validateForm = () => {
        const { firstName, lastName, designation, contact } = currentParticipant;
        if (!firstName || firstName.length < 2 || firstName.length > 20) {
            toast.error('First name must be between 2 and 20 characters');
            return false;
        }
        if (!lastName || lastName.length < 2 || lastName.length > 20) {
            toast.error('Last name must be between 2 and 20 characters');
            return false;
        }
        if (!designation || designation.length < 2 || designation.length > 20) {
            toast.error('Designation must be between 2 and 20 characters');
            return false;
        }
        if (!contact || contact.length < 8 || contact.length > 15) {
            toast.error('Contact number must be between 8 and 15 characters');
            return false;
        }
        return true;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCurrentParticipant((prev) => ({
            ...prev,
            [name]: value,
        }));
        setValidated(false);
    };

    const handlePhoneChange = (phone) => {
        setCurrentParticipant((prev) => ({
            ...prev,
            contact: phone,
        }));
        setValidated(false);
    };


    const addParticipant = () => {
        setValidated(true);
        if (!validateForm()) {
            return;
        }

        if (formData.participants.length >= 3) {
            toast.error('You can add a maximum of 3 participants.');
            return;
        }

        setFormData((prevFormData) => ({
            ...prevFormData,
            participants: [...prevFormData.participants, currentParticipant],
        }));

        setCurrentParticipant({
            firstName: '',
            lastName: '',
            designation: '',
            contact: '',
        });
        setValidated(false);
        toast.success('Participant added successfully!');
    };


    const deleteParticipant = (index) => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            participants: prevFormData.participants.filter((_, i) => i !== index),
        }));
        toast.success('Participant removed successfully!');
    };

    return (
        <Form noValidate validated={validated}>
            <h5 className="fw-bold">Representative Information <span className="text-danger fw-bold">*</span></h5>
            <div className='text-xs text-danger fw-bold' style={{ fontSize: '0.9rem' }}>
                <span className="text-danger">*</span> In this section, the Collaborator can enter the details of the representatives who will attend the B2B virtual meeting. You can add information for up to three representatives.
            </div>
            <hr />

            <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="validationCustom01">
                    <Form.Label className='fs-6'>First Name*</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        minLength={2}
                        maxLength={20}
                        onChange={handleInputChange}
                        value={currentParticipant.firstName || ''}
                        name="firstName"
                        placeholder="First Name"
                    />
                    <Form.Control.Feedback type="invalid">
                        First name must be between 2 and 20 characters.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom02">
                    <Form.Label className='fs-6'>Last Name*</Form.Label>
                    <Form.Control
                        required
                        minLength={2}
                        maxLength={20}
                        type="text"
                        onChange={handleInputChange}
                        value={currentParticipant.lastName || ''}
                        name="lastName"
                        placeholder="Last Name"
                    />
                    <Form.Control.Feedback type="invalid">
                        Last name must be between 2 and 20 characters.
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <Row className="mb-3">
                <Form.Group as={Col} md="6" controlId="validationCustom04">
                    <Form.Label className='fs-6'>Designation*</Form.Label>
                    <Form.Control
                        required
                        minLength={2}
                        maxLength={20}
                        type="text"
                        placeholder="Designation"
                        onChange={handleInputChange}
                        value={currentParticipant.designation || ''}
                        name="designation"
                    />
                    <Form.Control.Feedback type="invalid">
                        Designation must be between 2 and 20 characters.
                    </Form.Control.Feedback>
                </Form.Group>
                <Form.Group as={Col} md="6" controlId="validationCustom05">
                    <Form.Label className='fs-6'>Office Number/Mobile Number/WhatsApp*</Form.Label>
                    <PhoneInput
                        country={'in'}
                        containerClass="w-100"
                        value={currentParticipant.contact || ''}
                        onChange={handlePhoneChange}
                        inputClass="form-control w-100"
                        placeholder="Enter phone number"
                    />
                    <Form.Control.Feedback type="invalid">
                        Contact number must be between 8 and 15 characters.
                    </Form.Control.Feedback>
                </Form.Group>
            </Row>
            <div className="d-flex justify-content-between">
                <div className='fw-semibold text-danger'>Add upto 3 Representative*</div>
                <Button
                    variant="primary"
                    onClick={addParticipant}
                    size='sm'
                    disabled={formData.participants.length >= 3}
                    className="mb-3"
                >
                    Add Representative  +
                </Button>
            </div>
            {formData.participants.length > 0 && (
                <>
            <hr />
                <div className="mb-3">
                    <h6 className='fw-bold fs-5'>Added Participants:</h6>
                    <ListGroup>
                        {formData.participants.map((participant, index) => (
                            <ListGroup.Item key={index}>
                                <div className="d-flex justify-content-between">
                                    <div>
                                        {participant.firstName} {participant.lastName} - {participant.designation} ({participant.contact})
                                    </div>
                                    <Button
                                        variant="danger"
                                        size="sm"
                                        onClick={() => deleteParticipant(index)}
                                        className="ms-2"
                                    >
                                        Remove
                                    </Button>
                                </div>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </div>
                </>
            )}
            <hr/>
        </Form>
    );
};

export default UserInformation;